<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="d-flex justify-content-between">
        <div class="text-right m-4">
          <h5 style="font-size: 1vw !important"> ریشه علل مسئله   / {{$route.params.title}}  </h5>
        </div>
        <div class="d-flex" v-if="allItems.length">
          <a   :href="`${this.download_url}/rootCauses/all/word/by/id/${id_user}`" style="margin-top: 1.3vw;"
             class="btn btn-primary btn-submit-1">خروجی Word</a>
          <a   :href="`${this.download_url}/rootCauses/all/pdf/by/id/${id_user}`"
             style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 1vw;" class="btn btn-primary btn-submit-1">خروجی
            PDF</a>
          <a    style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; " class="btn btn-primary btn-submit-1 "
                :style="!status_show ? 'background-color: red; border-color: red' : 'background-color: green; border-color: green'"
                @click="acceptComplete"
          >
            <div v-if="!status_loading">

              <span v-if="!status_show">  تایید وضعیت</span>
              <span v-else>عدم تایید</span>
            </div>
            <div v-else>
              <div class="loader-line"></div>

            </div>
          </a>
        </div>

      </div>
      <div class="table-responsive p-5">
        <center v-show="!allItems.length">
          اطلاعاتی یافت نشد!
        </center>
        <div style="overflow-y: scroll; height: 50vw;" :style="allItems.length < 19 ? 'height: auto;' : ''">

        <table v-show="allItems.length" class="table table-striped bg-white" >
          <tbody>
          <tr>
            <th rowspan="2"><strong>ردیف</strong></th>


            <th rowspan="2"><strong>مسئله
              (به ترتیب اولویت)
            </strong></th>
            <th rowspan="2" ><strong>     روش ریشه‌یابی </strong></th>
            <th style="width: 4vw;"><strong>عوامل ریشه‌ای</strong></th>

          </tr>
          <tr>



          </tr>
          <tr  v-for="(item,index) in allItems">
            <td style="width: 1vw;">{{index+1}}</td>
            <td>{{item.problem_identifications.title}}  </td>
            <td style="width: 11vw;">
              {{item.root_causes_problem && item.root_causes_problem.method}}

            </td>
            <td>
              <button @click="modalSaveModal(item.id)" class="btn btn-primary btn-submit-1"> مشاهده </button>
            </td>





          </tr>


          </tbody>
        </table>
      </div>
      </div>
      <center>

      </center>

    </div>
  </div>
  <div v-show="modalSave" class="modal__error slide-top" style="width: 50vw; z-index: 9999">
    <div class="d-flex justify-content-between flex-row-reverse">
      <p>عوامل ریشه ای</p>
      <p @click="modalSave=!modalSave">❌</p>
    </div>


    <div style="overflow-y: scroll; height: 14vw;">
      <table v-if="allItemsOther.length" style="direction: rtl; height: 20vw;"  class="table table-striped bg-white" >
        <tbody>
        <tr>
          <th rowspan="2"><strong>ردیف</strong></th>
          <th rowspan="2"><strong>
            عامل ریشه ای
          </strong></th>
          <th rowspan="2" ><strong>     نوع   </strong></th>
          <th><strong>   نیروی انسانی  </strong></th>
          <th><strong>   سرمایه  </strong></th>
          <th><strong>  فناوری    </strong></th>
          <th><strong>   مدیریت  </strong></th>
          <th><strong>   سایر  </strong></th>

        </tr>

        </tbody>
        <tr v-for="(item, index) in allItemsOther">
          <td>{{index+1}}</td>
          <td>{{item.title}}</td>
          <td>{{item.type}}</td>
          <td>{{item.is_human ? '✅':''}}</td>
          <td>{{item.is_fund ? '✅':''}}</td>
          <td>{{item.is_technology ? '✅':''}}</td>
          <td>{{item.is_management ? '✅':''}}</td>
          <td>{{item.other}}</td>

        </tr>
      </table>
      <center v-else>
        موردی یافت نشد
      </center>
    </div>


  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import {useToast} from "vue-toastification";
import router from "@/router";
const toast = useToast();

export default {
  components: {
    Sidebar,
    splash
  },
  data() {
    return {
      allItems: [],
      id_route: this.$route['params']['id'],
      allItemsOther: [],
      id_user: '',
      other_root: '',
      management_root: '',
      tech_root: '',
      money_root: '',
      is_human_root: '',
      type_root: '',
      title_root: '',
      id_root: '',
      modalSave: false,
      status_show: false,
      status_loading: false,


    }
  },
  methods: {
    acceptComplete(){
      if (this.status_loading){
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error){
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message){
              toast.success(response.message)
              this.status_show=!this.status_show
              this.status_loading = false
              this.all()
            }

          })
          .catch();
    },
    resetData(){
      this.other_root = ''
      this.management_root = 0
      this.tech_root = 0
      this.money_root = 0
      this.is_human_root = 0
      this.type_root = ''
      this.title_root = ''


    },
    modalSaveModal(id){
      this.resetData()
      this.modalSave= true
      this.id_root= id
      this.fetchOther(id)
    },
    fetchOther(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/save_RootCausesProblemAnalysis/all/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.allItemsOther.length = 0
            response.all.forEach((item) => {
              this.allItemsOther.push(item)

            })
          })
          .catch();
    },
    store_root(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('causes_id', parseInt(id))
      formdata.append('title', this.title_root)
      formdata.append('type',this.type_root)
      formdata.append('is_human', this.is_human_root===true ? 1 : 0)
      formdata.append('is_fund',this.money_root===true ? 1 : 0)
      formdata.append('is_technology', this.tech_root===true ? 1 : 0)
      formdata.append('is_management',this.management_root===true ? 1 : 0)
      formdata.append('other',this.other_root)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/save_RootCausesProblemAnalysis`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.resetData()
            this.fetchOther(id)


          })
          .catch();
    },

    all() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/all_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            if (response.status){
              this.status_show = true
            }
            this.allItems.length = 0
            response.all.forEach((item) => {
              this.allItems.push(item)

            })
          })
          .catch();
    },
    store(){
      let obj = []
      this.allItems.forEach((ele)=>{
        const method = document.getElementById(`method_${ele.id}`).value

        const item = {
          'id': ele.root_causes_problem ? ele.root_causes_problem.id : '',
          'prioritizing_issues_id': ele.id,
          'method': method,
        }
        obj.push(item)
      })

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('all', JSON.stringify(obj))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/rootCauses/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.all()

          })
          .catch();

    },
    checkIsMother() {
      if (!this.is_mother) {
        router.push('/pishkhan')
      }
    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error){
              this.logout()
              return;
            }
            if (result['item']) {
               if (this.is_mother){
              this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },


  },
  mounted() {
    this.all()
    this.checkIsMother()
  },
}
</script>
<style scoped lang="scss"></style>